import React, { useState, useEffect, useCallback, useRef } from "react";
import { useWatchState, setState, handler, useDebounce } from "@/store";
import { checkResult, createSelectOption } from "@/common";
import { Upload } from "@/components";
import BraftEditor from "braft-editor";
import { BaseService, uploadUrl, TYCService } from "@/service";
import {
  demandSource,
  assets,
  capital,
  technology,
  companyScale,
  level,
  dockingType,
} from "@/dic";
import { toArr } from "@/utils";
import {
  Modal,
  Button,
  Form,
  Input,
  message,
  Menu,
  Select,
  Cascader,
  Icon,
  Dropdown,
  Row,
  Col,
  Steps,
  Carousel,
} from "antd";

const { Step } = Steps;
const TABLE_NAME = "thtt_xuqiu";
const NAME = "demandHZ";

function cacheOrg(org) {
  localStorage.setItem("cacheOrg", JSON.stringify(org));
}

function getCacheOrg() {
  const cahceOrg = localStorage.getItem("cacheOrg");
  return cahceOrg ? JSON.parse(cahceOrg) : false;
}

// 月份信息
let date = new Date().format().split("-");
date[2] = "01";

async function getNewCode() {
  const res = await BaseService.list({
    table: TABLE_NAME,
    columns: "code",
    pageSize: 1,
    pageIndex: 1,
    where: {
      is_delete: 0,
      add_time: {
        condition: ">",
        value: Math.floor(new Date(date.join("-")) / 1000),
      },
    },
    order: ["add_time DESC"],
  });
  const code = res.data.result.records[0]
    ? res.data.result.records[0].code
    : "0";
  return !code ? 0 : parseInt(code.substr(-3, 3));
}

async function getPosCode(province, city, area) {
  const res = await BaseService.list({
    table: "thtt_post_code",
    columns: "post_code",
    where: {
      province,
      city,
      area,
    },
  });
  const code =
    res.data.result && res.data.result[0]
      ? res.data.result[0].post_code
      : "000000";
  return code;
}

const App = Form.create({ name: "register" })(({ form }) => {
  const { getFieldDecorator } = form;

  const [loading, setLoading] = useState(false);

  const [[i18n]] = useWatchState(["i18n"]);
  const [[PLATFORM]] = useWatchState(["PLATFORM"]);
  const [[COUNTRY]] = useWatchState(["$_COUNTRY"]);
  const [[LANG]] = useWatchState(["LANG"]);
  const [[user]] = useWatchState(["user"]);
  const [[SCOPE_DIRECTION = []]] = useWatchState(["$_SCOPE_DIRECTION"]);
  const { user_id, authority = "" } = user.info;
  const IS_ADMIN = authority && authority.includes("xq-auditor");
  const IS_INPUT = authority && authority.includes("xq-input");
  const [[modalProps, setProps]] = useWatchState(["modal." + NAME]);
  const {
    title = i18n.cloudMatch.releaseBtn.releaseDemand,
    show,
    hide,
    width = 900,
    vo = { sub_type: 1 },
    state,
    contrast,
    callback,
    scopes = [],
    files = {},
  } = modalProps;
  const audit = state === "audit";
  const [[UPLOAD_SERVER_HOST = ""]] = useWatchState(["$_UPLOAD_SERVER_HOST"]);
  const [[REGIONS = []]] = useWatchState(["$_REGIONS"]);

  const carousel = useRef();
  const [current, setCurrent] = useState(0);
  const [profile, setProfile] = useState("");
  const [orgProfile, setOrgProfile] = useState("");
  const steps = [
    { title: i18n.demandModal.steps.demand },
    { title: i18n.demandModal.steps.org },
  ];

  useEffect(() => {
    if (carousel.current) carousel.current.goTo(current);
  }, [current]);

  const [searchResult, setSearchResult] = useState([]);
  const [showSearchRes, setShowSearchRes] = useState(false);
  const [selectOrgVo, setSelectOrg] = useState();

  useEffect(() => {
    if (!show) {
      setSelectOrg();
      setCurrent(0);
    } else {
      // 设置默认机构
      if (state === "add") {
        const cacheOrg = getCacheOrg();
        if (cacheOrg) selectOrg(cacheOrg);
      }
      if (!IS_INPUT) getMyOrgs();
    }
  }, [show]);

  const orgHandle = async (vo) => {
    const add_time = parseInt(new Date().getTime() / 1000);

    let unit_id = "";
    let org = {};

    if (vo.org_type !== undefined) org.type = vo.org_type;
    if (vo.org_level !== undefined) org.level = vo.org_level;
    if (vo.org_name) org.name = vo.org_name;
    if (vo.org_window_name) org.window_name = vo.org_window_name;
    if (vo.org_web_site) org.web_site = vo.org_web_site;
    if (orgProfile) org.profile = orgProfile;
    if (vo.org_economic_circle) org.economic_circle = vo.org_economic_circle;
    if (vo.org_assets) org.assets = vo.org_assets;
    if (vo.org_technology) org.technology = vo.org_technology;
    if (vo.org_capital) org.capital = vo.org_capital;
    if (vo.org_staff_num_range) org.staff_num_range = vo.org_staff_num_range;

    // 将需求的负责人、联系人、联系电话赋值给机构
    if (vo.director) org.director = vo.director;
    if (vo.contacts) org.contacts = vo.contacts;
    if (vo.contacts_email) org.contacts_email = vo.contacts_email;
    if (vo.scope) org.industry = vo.scope;

    if (vo.org_provinceName) org.provinceName = vo.org_provinceName;
    if (vo.org_cityName) org.cityName = vo.org_cityName;
    if (vo.org_countyName) org.countyName = vo.org_countyName;
    if (vo.org_province) org.province = vo.org_province;
    if (vo.org_city) org.city = vo.org_city;
    if (vo.org_county) org.county = vo.org_county;
    if (vo.org_country) org.country = vo.org_country;
    if (vo.org_address) org.address = vo.org_address;

    // 保存机构信息
    if (selectOrgVo && selectOrgVo.name === vo.org_name) {
      org.estiblish_time = selectOrgVo.estiblishTime;
      org.legal_person_name = selectOrgVo.legalPersonName;
      org.tyc_org_id = selectOrgVo.id;
      org.tyc_type = selectOrgVo.companyType;
      org.social_credit_code = selectOrgVo.creditCode;
      org.organization_code = selectOrgVo.orgNumber;
      org.reg_number = selectOrgVo.regNumber;
      org.legal_type = selectOrgVo.type;
    }
    // 先查询是否已经存在
    let list = [];
    if (vo.org_name) {
      const getRes = await BaseService.list({
        table: "thtt_organization",
        where: {
          name: vo.org_name,
          is_delete: 0,
        },
      });
      list = getRes.data.result;
    }

    // 修改
    if (list.length) {
      const organization_id = list[0].organization_id;
      unit_id = organization_id;
      await BaseService.put({
        table: "thtt_organization",
        data: org,
        where: { organization_id },
      });
    } else {
      // 新增
      if (!org.name) return;
      const addRes = await BaseService.add({
        table: "thtt_organization",
        data: {
          ...org,
          is_delete: 0,
          add_time,
          audit_status: 4,
          user_id: user_id,
          type: 4,
        },
        key: "organization_id",
      });
      if (!checkResult(addRes)) return setLoading(false);
      unit_id = addRes.data.result.organization_id;
      cacheOrg(addRes.data.result);

      // 新增机构用户
      const addUserRes = await BaseService.add({
        table: "thtt_organization_user",
        data: {
          organization_id: unit_id,
          user_id: user_id,
          is_admin: 1,
          is_delete: 0,
          add_time,
          audit_status: 4,
        },
      });
      if (!checkResult(addUserRes)) return setLoading(false);
    }

    return unit_id;
  };

  const add = async (vo) => {
    if (!user_id) {
      message.error("用户信息错误！");
      return;
    }

    const add_time = parseInt(new Date().getTime() / 1000);

    setLoading(true);

    const unit_id = await orgHandle(vo);
    const num = await getNewCode();

    const code =
      "XQ" + date[0].substr(-2, 2) + date[1] + (num + 1 + "").padStart(3, 0);

    // 非录入员身份，来源默认为2
    if (!IS_INPUT) vo.source = 2;

    try {
      let data = {
        ...vo,
        code,
        platform: PLATFORM,
        add_time,
        release_time: add_time,
        sort_time: add_time,
        unit: unit_id,
        is_delete: 0,
        add_user: user_id,
        audit_status: 1,
        complete_time: new Date().format("yyyy-MM-dd hh:mm:ss"),
      };
      if (IS_ADMIN) data.audit_status = 4;

      const res = await BaseService.add({
        table: TABLE_NAME,
        data,
        key: "xuqiu_id",
      });
      if (!checkResult(res)) return setLoading(false);
      const xuqiu_id = res.data.result.xuqiu_id;
      // 保存需求领域
      const scopeRes = await BaseService.adds({
        table: "thtt_xuqiu_scope",
        data: JSON.stringify(
          scopes.map(({ value, pid }) => ({
            xuqiu_id,
            first_scope_id: pid,
            second_scope_id: value,
          }))
        ),
      });
      let _files = [];
      Object.values(files).forEach((arr) => (_files = _files.concat(arr)));
      const addFileRes = await BaseService.adds({
        table: "thtt_attachment_relation",
        data: JSON.stringify(
          _files.map((val) => ({ ...val, item_id: xuqiu_id }))
        ),
      });
      setLoading(false);
      if (!checkResult(scopeRes)) return;
      message.success(i18n.releaseSuccess);

      // 提示是否需要智能匹配
      // confirmMatch({
      //   type: "demand",
      //   defaultFileList: _files,
      //   onOk: async function (resFiles) {
      //     if (!resFiles.length) {
      //       message.warn("您没有上传更多的材料，暂时无法为您进行匹配服务！");
      //       return;
      //     }
      //     await BaseService.put({
      //       table: "thtt_xuqiu",
      //       where: {
      //         xuqiu_id,
      //       },
      //       data: {
      //         level: 1,
      //       },
      //     });
      //     await BaseService.remove({
      //       table: "thtt_attachment_relation",
      //       where: {
      //         item_id: xuqiu_id,
      //         type: JSON.stringify(Object.keys(files)),
      //       },
      //     });
      //     await BaseService.adds({
      //       table: "thtt_attachment_relation",
      //       data: JSON.stringify(resFiles),
      //     });
      //     if (callback) callback();
      //   },
      //   onCancel: function () {},
      // });

      hide();
      if (callback) callback();
    } catch (error) {
      setLoading(false);
    }
  };

  const put = async (values) => {
    const update_time = Math.floor(new Date() / 1000);
    let vo = contrast(values, ["xuqiu_id", "org_name"]);
    setLoading(true);
    try {
      const unit_id = await orgHandle(vo);

      const res = await BaseService.put({
        table: TABLE_NAME,
        data: { ...vo, update_time, unit: unit_id },
        where: { xuqiu_id: vo.xuqiu_id },
      });
      if (!checkResult(res)) return setLoading(false);

      await BaseService.remove({
        table: "thtt_xuqiu_scope",
        where: {
          xuqiu_id: vo.xuqiu_id,
        },
      });
      await BaseService.adds({
        table: "thtt_xuqiu_scope",
        data: JSON.stringify(
          scopes.map(({ value, pid }) => ({
            xuqiu_id: vo.xuqiu_id,
            first_scope_id: pid,
            second_scope_id: value,
          }))
        ),
      });
      let _files = [];
      Object.values(files).forEach((arr) => (_files = _files.concat(arr)));
      await BaseService.remove({
        table: "thtt_attachment_relation",
        where: {
          item_id: vo.xuqiu_id,
          type: JSON.stringify(Object.keys(files)),
        },
      });
      await BaseService.adds({
        table: "thtt_attachment_relation",
        data: JSON.stringify(_files),
      });

      setLoading(false);
      message.success("修改成功！");
      hide();
      if (callback) callback();
    } catch (error) {
      setLoading(false);
      throw error;
    }
  };

  const funs = { add, put };

  const checkSubmit = (index) => {
    form.validateFieldsAndScroll(async (err, values) => {
      console.log(err);
      if (!err) {
        setCurrent(index);
      }
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        const data = { ...vo, ...values, cover: vo.cover };

        if (!profile && !data.old_profile)
          return message.warn("请输入成果简介！");

        data.profile = profile || data.old_profile;

        // 如果是已审核状态，提示需要重新审核！
        if (!IS_ADMIN && vo.audit_status === 4) {
          Modal.confirm({
            title: "确认修改需求信息吗?",
            content: "提交修改后，管理员需要重新审核！",
            onOk() {
              data.audit_status = 1;
              funs[state](data);
            },
          });
          return;
        }

        funs[state](data);
      }
    });
  };

  const onUploadFinish = (e) => {
    const url = e.file.response.files[0].url;
    modalProps.vo.cover = url;
    setProps({ ...modalProps });
  };

  const onUploadFileFinish = (type, e) => {
    const size = e.file.size;
    const add_time = new Date().format("yyyy-MM-dd hh:mm:ss");
    const newFiles = e.file.response.files.map(
      ({ fileShowName, suffix, url }) => ({
        type,
        item_id: vo.xuqiu_id,
        file_name: fileShowName,
        file_path: url,
        file_suffix: suffix,
        size,
        add_time,
      })
    );
    if (!modalProps.files) modalProps.files = {};
    if (!modalProps.files[type]) modalProps.files[type] = newFiles;
    else modalProps.files[type] = modalProps.files[type].concat(newFiles);
    setProps({ ...modalProps });
  };
  const onRemoveFile = (type, file) => {
    modalProps.files[type].remove(file.uid - 1);
    setProps({ ...modalProps });
  };

  // 选中搜索结果
  const selectOrg = (org) => {
    const { name } = org;
    setSelectOrg(org);
    form.setFieldsValue({
      org_name: name,
    });
    getAndRefreshOrg(name);
    cacheOrg(org);
  };

  const getAndRefreshOrg = (name) => {
    BaseService.list({
      table: "thtt_organization",
      columns: [
        "organization_id",
        "name",
        "type",
        "level",
        "window_name",
        "web_site",
        "director",
        "profile",
        "reg_location",
        "contacts",
        "contacts_email",
        "industry",
        "wechat",
        "economic_circle",
        "assets",
        "technology",
        "capital",
        "staff_num_range",
        "talent",
        "equipment",
        "business_direction",
        "performance",
        "team_scale",
        "province",
        "city",
        "county",
        "country",
        "provinceName",
        "cityName",
        "countyName",
        "address",
      ]
        .map((field) => `${field} AS org_${field}`)
        .join(","),
      where: { name, is_delete: 0 },
    }).then((res) => {
      if (!checkResult(res)) return;
      const data = res.data.result;
      if (data.length) {
        const org = data[0];
        org.org_profile = BraftEditor.createEditorState(org.org_profile);

        // 将机构的负责人、联系人、联系信息赋值给需求
        modalProps.vo.director = org.org_director;
        modalProps.vo.contacts = org.org_contacts;
        modalProps.vo.contacts_email = org.org_contacts_email;
        modalProps.vo.scope = org.org_industry;

        modalProps.vo = {
          ...modalProps.vo,
          ...org,
        };
        setTimeout(() => {
          setProps({ ...modalProps });
        });
        console.log(org.org_profile);
        form.setFieldsValue(org);
      }
    });
  };

  const getMenu = (data = []) => {
    return (
      <Menu
        className="search_result_list"
        style={{ height: "200px", overflow: "auto" }}
      >
        {data.map((org) => (
          <Menu.Item
            keys={org.name}
            onClick={selectOrg.later({
              ...org,
              name: org.name && org.name.getBytesContent(),
            })}
          >
            <div dangerouslySetInnerHTML={{ __html: org.name }} />
          </Menu.Item>
        ))}
      </Menu>
    );
  };

  const onChnageOrgName = useDebounce((word) => {
    if (IS_INPUT)
      TYCService.search({ word }).then(
        (res) => {
          if (!checkResult(res)) return;
          setSearchResult(res.data.result.records || res.data.result.items);
        },
        (err) => {
          throw err;
        }
      );
    else
      BaseService.list({
        table: "thtt_organization_user",
        leftJoin: {
          table: "thtt_organization",
          on: "thtt_organization.organization_id = thtt_organization_user.organization_id",
          columns: ["name"],
        },
        where: {
          "thtt_organization_user.user_id": user_id,
          "thtt_organization.name": {
            condition: "LIKE",
            value: word,
          },
          "thtt_organization.is_delete": 0,
        },
      }).then((res) => {
        if (!checkResult(res)) return;
        setSearchResult(res.data.result);
      });
  }, 200);

  const getMyOrgs = useCallback(() => {
    BaseService.list({
      table: "thtt_organization_user",
      leftJoin: {
        table: "thtt_organization",
        on: "thtt_organization.organization_id = thtt_organization_user.organization_id",
        columns: ["name"],
      },
      where: {
        "thtt_organization_user.user_id": user_id,
        "thtt_organization.is_delete": 0,
      },
    }).then((res) => {
      if (!checkResult(res)) return;
      setSearchResult(res.data.result);
    });
  }, []);

  const onChangeOrgProfile = (e) => {
    setOrgProfile(e.toHTML());
  };

  const onChangeProfile = (e) => {
    setProfile(e.toHTML());
  };

  return (
    <Modal
      title={title}
      visible={show}
      width={width}
      maskClosable={false}
      onCancel={hide}
      footer={
        <div>
          {current > 0 && (
            <Button onClick={checkSubmit.bind(null, current - 1)}>
              {i18n.demandModal.back}
            </Button>
          )}
          {current !== steps.length - 1 && (
            <Button onClick={checkSubmit.bind(null, current + 1)}>
              {i18n.demandModal.next}
            </Button>
          )}
          {current === steps.length - 1 && (
            <Button onClick={handleSubmit}>{i18n.demandModal.submit}</Button>
          )}
        </div>
      }
      destroyOnClose={true}
    >
      <div className={audit && "not-allowed"}>
        {/* 进度 */}
        <Steps type="navigation" current={current}>
          {steps.map((item) => (
            <Step key={item.title} title={item.title} />
          ))}
        </Steps>
        <div
          className="over-y-auto over-x-hide m-md-t"
          style={{ height: "60vh" }}
        >
          <Form onSubmit={handleSubmit} className={audit && "no-click"}>
            <Carousel ref={carousel} dots={false}>
              {/* 需求信息 */}
              <div>
                <Row gutter={18}>
                  <Col span={12}>
                    <Form.Item label={i18n.demandModal.demandForm.name}>
                      {getFieldDecorator("name", {
                        initialValue: vo.name,
                        rules: [
                          {
                            required: true,
                            message: i18n.demandModal.demandForm.nameMessage,
                          },
                        ],
                      })(
                        <Input
                          maxLength={200}
                          placeholder={
                            i18n.demandModal.demandForm.namePlaceholder
                          }
                        />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label={i18n.demandModal.demandForm.scope}>
                      {getFieldDecorator("scope", {
                        initialValue: toArr(vo.scope),
                        rules: [
                          {
                            required: true,
                            message: i18n.demandModal.demandForm.scopeMessage,
                          },
                        ],
                      })(
                        <Select
                          placeholder={
                            i18n.demandModal.demandForm.scopePlaceholder
                          }
                          mode="multiple"
                        >
                          {createSelectOption(
                            (SCOPE_DIRECTION || []).map((val) => ({
                              ...val,
                              en: val.name_en,
                            })),
                            LANG
                          )}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  {IS_INPUT && (
                    <Col span={8}>
                      <Form.Item label={i18n.demandModal.demandForm.source}>
                        {getFieldDecorator("source", {
                          initialValue: vo.source,
                        })(
                          <Select
                            placeholder={
                              i18n.demandModal.demandForm.sourcePlaceholder
                            }
                          >
                            {createSelectOption(demandSource)}
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                  )}
                  {IS_INPUT && (
                    <Col span={8}>
                      <Form.Item label={i18n.demandModal.demandForm.level}>
                        {getFieldDecorator("level", {
                          initialValue: vo.level,
                        })(
                          <Select
                            placeholder={
                              i18n.demandModal.demandForm.levelPlaceholder
                            }
                          >
                            {createSelectOption(level)}
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                  )}
                  {IS_INPUT && (
                    <Col span={8}>
                      <Form.Item
                        label={i18n.demandModal.demandForm.dockingType}
                      >
                        {getFieldDecorator("docking_type", {
                          initialValue: toArr(vo.docking_type),
                        })(
                          <Select
                            placeholder={
                              i18n.demandModal.demandForm.dockingTypePlaceholder
                            }
                            mode="multiple"
                          >
                            {createSelectOption(dockingType, LANG)}
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                  )}
                  {!audit && (
                    <Col span={24}>
                      <Form.Item label={i18n.demandModal.demandForm.enclosure}>
                        {getFieldDecorator("enclosure", {
                          initialValue: vo["enclosure"],
                        })(
                          <Upload
                            style={{ minWidth: "160px" }}
                            name="files"
                            onFinish={onUploadFileFinish.later("enclosure")}
                            action={uploadUrl}
                            defaultFileList={(files.enclosure || []).map(
                              ({ file_name, file_path }, i) => ({
                                name: file_name,
                                url: `http://${UPLOAD_SERVER_HOST}${file_path}`,
                                status: "done",
                                uid: i + 1,
                              })
                            )}
                            onRemove={onRemoveFile.later("enclosure")}
                          >
                            <Button>
                              <Icon type="upload" />{" "}
                              {i18n.demandModal.demandForm.uploadBtnTitle}
                            </Button>
                          </Upload>
                        )}
                      </Form.Item>
                    </Col>
                  )}
                </Row>
                <Form.Item label={i18n.demandModal.demandForm.profile} required>
                  <BraftEditor
                    className="border bor-ra-xs"
                    language="en"
                    defaultValue={vo.profile}
                    onChange={onChangeProfile}
                    placeholder={i18n.demandModal.demandForm.profilePlaceholder}
                  />
                </Form.Item>
              </div>
              {/* 需求企业信息 */}
              <div>
                {current > 0 && (
                  <div>
                    <Row gutter={18}>
                      <Col span={24}>
                        <Form.Item label={i18n.demandModal.orgForm.name}>
                          <Dropdown
                            overlay={getMenu(searchResult)}
                            visible={searchResult.length && showSearchRes}
                          >
                            {getFieldDecorator("org_name", {
                              initialValue: vo.org_name,
                              rules: [
                                {
                                  required: true,
                                  message: i18n.demandModal.orgForm.nameMessage,
                                },
                              ],
                            })(
                              <Input
                                onChange={(e) => {
                                  const word = e.target.value;
                                  if (!word) {
                                    setSearchResult([]);
                                    return;
                                  }
                                  if (word) onChnageOrgName(word);
                                }}
                                maxLength={100}
                                onFocus={setShowSearchRes.later(true)}
                                onBlur={() =>
                                  setTimeout(() => setShowSearchRes(false), 100)
                                }
                                placeholder={
                                  i18n.demandModal.orgForm.namePlaceholder
                                }
                                autoComplete="off"
                              />
                            )}
                          </Dropdown>
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item label={i18n.demandModal.orgForm.country}>
                          {getFieldDecorator("org_country", {
                            initialValue: parseInt(vo.org_country),
                            rules: [
                              {
                                required: true,
                                message:
                                  i18n.demandModal.orgForm.countryMessage,
                              },
                            ],
                          })(
                            <Select
                              showSearch
                              placeholder={
                                i18n.demandModal.orgForm.countryPlaceholder
                              }
                              filterOption={(input, option) =>
                                option.props.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                            >
                              {createSelectOption(COUNTRY, LANG, "en_name")}
                            </Select>
                          )}
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item label={i18n.demandModal.orgForm.contacts}>
                          {getFieldDecorator("contacts", {
                            initialValue: vo.contacts,
                            rules: [
                              {
                                required: true,
                                message:
                                  i18n.demandModal.orgForm.contactsMessage,
                              },
                            ],
                          })(
                            <Input
                              maxLength={50}
                              placeholder={
                                i18n.demandModal.orgForm.contactsPlaceholder
                              }
                            />
                          )}
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item
                          label={i18n.demandModal.orgForm.contactsEmail}
                        >
                          {getFieldDecorator("contacts_email", {
                            initialValue: vo.contacts_email,
                            rules: [
                              {
                                required: true,
                                message:
                                  i18n.demandModal.orgForm.contactsEmailMessage,
                              },
                            ],
                          })(
                            <Input
                              maxLength={100}
                              placeholder={
                                i18n.demandModal.orgForm
                                  .contactsEmailPlaceholder
                              }
                            />
                          )}
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item label={i18n.resultModal.orgForm.address}>
                          {getFieldDecorator("org_address", {
                            initialValue: vo.org_address,
                          })(
                            <Input
                              maxLength={100}
                              placeholder={
                                i18n.resultModal.orgForm.addressPlaceholder
                              }
                            />
                          )}
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item label={i18n.demandModal.orgForm.webSite}>
                          {getFieldDecorator("org_web_site", {
                            initialValue: vo.org_web_site,
                          })(
                            <Input
                              maxLength={200}
                              placeholder={
                                i18n.demandModal.orgForm.webSitePlaceholder
                              }
                            />
                          )}
                        </Form.Item>
                      </Col>

                      {/* <Col span={12}>
                        <Form.Item label="经济圈划定">
                          {getFieldDecorator("org_economic_circle", {
                            initialValue: vo.org_economic_circle,
                          })(
                            <Select placeholder="请选择经济圈划定">
                              {createSelectOption(economicCircle)}
                            </Select>
                          )}
                        </Form.Item>
                      </Col> */}
                      <Col span={12}>
                        <Form.Item label={i18n.demandModal.orgForm.assets}>
                          {getFieldDecorator("org_assets", {
                            initialValue: vo["org_assets"] || undefined,
                          })(
                            <Select
                              placeholder={
                                i18n.demandModal.orgForm.assetsPlaceholder
                              }
                            >
                              {createSelectOption(assets, LANG)}
                            </Select>
                          )}
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item label={i18n.demandModal.orgForm.technology}>
                          {getFieldDecorator("org_technology", {
                            initialValue: vo["org_technology"] || undefined,
                          })(
                            <Select
                              placeholder={
                                i18n.demandModal.orgForm.technologyPlaceholder
                              }
                            >
                              {createSelectOption(technology, LANG)}
                            </Select>
                          )}
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item label={i18n.demandModal.orgForm.capital}>
                          {getFieldDecorator("org_capital", {
                            initialValue: vo["org_capital"] || undefined,
                          })(
                            <Select
                              placeholder={
                                i18n.demandModal.orgForm.capitalPlaceholder
                              }
                            >
                              {createSelectOption(capital, LANG)}
                            </Select>
                          )}
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item label={i18n.demandModal.orgForm.range}>
                          {getFieldDecorator("org_staff_num_range", {
                            initialValue: vo.org_staff_num_range,
                          })(
                            <Select
                              placeholder={
                                i18n.demandModal.orgForm.rangePlaceholder
                              }
                            >
                              {createSelectOption(companyScale, LANG)}
                            </Select>
                          )}
                        </Form.Item>
                      </Col>
                      <Col span={24}>
                        <Form.Item label={i18n.demandModal.orgForm.profile}>
                          <BraftEditor
                            className="border bor-ra-xs"
                            language="en"
                            defaultValue={vo.org_profile}
                            onChange={onChangeOrgProfile}
                            placeholder={
                              i18n.demandModal.orgForm.profilePlaceholder
                            }
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </div>
                )}
              </div>
            </Carousel>
          </Form>
        </div>
      </div>
    </Modal>
  );
});

export default App;
